export const ONBOARDING_HANDOFF_READY_STORAGE_KEY = 'onboarding-handoff-ready'

// TODO(B2B auth): Remove this browser-local handoff marker together with the
// temporary Flow-to-Customer localStorage token bridge.
const HANDOFF_READY = 'ready'

export const isRegistrationSessionHandoffReady = () => {
  try {
    return (
      window.localStorage.getItem(ONBOARDING_HANDOFF_READY_STORAGE_KEY) ===
      HANDOFF_READY
    )
  } catch {
    return false
  }
}

export const markRegistrationSessionHandoffReady = () => {
  try {
    window.localStorage.setItem(
      ONBOARDING_HANDOFF_READY_STORAGE_KEY,
      HANDOFF_READY
    )
  } catch {
    return
  }
}

export const clearRegistrationSessionHandoff = () => {
  try {
    window.localStorage.removeItem(ONBOARDING_HANDOFF_READY_STORAGE_KEY)
  } catch {
    return
  }
}
